module.exports = __webpack_public_path__ + "img/PPMPprint1.bd7e5b2a.png";